<template>
  <select2
    :required="!atLeastSectorSelected"
    :options="options"
    v-model="selected"
    placeholder="Investor Type"
    parent="investor"
  >
  </select2>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Select2 from "./Select2Wrapper.vue";

export default {
  name: "InvestorTypeDropDown",
  components: {
    select2: Select2
  },
  data: function() {
    return {
      selected: ""
    };
  },
  computed: {
    ...mapGetters([
      "providerTypes",
      "selectedDropdownSector",
      "fundingNeed",
      "selectedDropdownProviderType"
    ]),
    atLeastSectorSelected() {
      return this.selectedDropdownSector != undefined;
    },
    options: function() {
      var opt = [
        {
          id: 0,
          text: "All"
        }
      ];
      opt.push(
        ...this.providerTypes.map((providerType, i) => {
          return {
            id: providerType.code,
            text: providerType.name
          };
        })
      );
      return opt;
    }
  },
  methods: {
    ...mapMutations({
      setProvidersType: "setProviderTypesParam",
      setDropdownProviderType: "setDropdownProviderType"
    })
  },
  watch: {
    selected: function(value) {
      if (value == "0") {
        this.setProvidersType();
      } else if (value != null) {
        var providerType = this.providerTypes.filter(
          item => item.code == value
        )[0];
        this.setProvidersType(providerType);
      }
      this.setDropdownProviderType(value);
    }
  },
  mounted() {
    if (this.selectedDropdownProviderType) {
      this.selected = this.selectedDropdownProviderType;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/SearchBar/InvestorTypeDropDown.vue